import type { Data } from "@puckeditor/core";
import type {
  OptimizationAnalysisResult,
  OptimizationApplyResult,
} from "@ease/page-builder/services";

export function applyOptimizationResultToEditorData(
  currentData: Data,
  result: OptimizationApplyResult,
): Data {
  return {
    ...currentData,
    content: result.components as Data["content"],
  };
}

export function buildHeatmapLookup(
  analysis: OptimizationAnalysisResult,
): Record<string, number> {
  return Object.fromEntries(
    analysis.heatmap
      .filter((item) => typeof item.componentId === "string" && item.componentId.length > 0)
      .map((item) => [item.componentId!, item.attention]),
  );
}
